export default __webpack_public_path__ + "static/media/7.cec5c393.jpeg";